

















import { defineComponent } from "@vue/composition-api";
import { QuickTip } from "@/types";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "QuickTipsItem",
  components: { BaseIcon },
  props: {
    item: { type: Object as () => QuickTip, required: true },
    type: { type: String as () => "warning" | "info" | "success", default: "info" },
  },
});
